import { Component, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../../shared/components/navbar/navbar.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth/services/auth.service';
import { CloseSideMenuDirective } from 'app/core/directives/close-side-menu.directive';
import { ProfileService } from './profile/services/profile.service';
import { EditSideMenuComponent } from './profile/components/profile-main-structure/edit-side-menu/edit-side-menu.component';

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    EditSideMenuComponent,
    CommonModule,
    CloseSideMenuDirective,
  ],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent {
  editHide: boolean = true;
  user: any = '';
  constructor(
    private observer: BreakpointObserver,
    private service: ProfileService,
    private auth: AuthService,
    public profile: ProfileService
  ) {
    this.auth.currentUser.subscribe((user: any) => {
      this.user = user?.user;
    });

    effect(() => {
      if (this.service.isOpened().status == true) {
        // document.body.style.overflowY = 'hidden';
        this.editHide = true;
      } else {
        // document.body.style.overflowY = 'auto';
        this.editHide = false;
      }
    });

    this.observer
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
        '(max-width:425px)',
      ])
      .subscribe((screenSizes: any) => {
        //['(max-width:800px)']
        if (screenSizes.matches) {
          if (screenSizes.breakpoints[Breakpoints.XSmall]) {
          }
        }
      });
  }

  editMenuToggle(event: any) {
    console.log('editMenuToggle', event);
    if (event) {
      document.body.style.overflowY = 'hidden';
      this.editHide = true;
    } else {
      document.body.style.overflowY = 'auto';
      this.editHide = false;

      this.service.changeEditStatus({
        type: this.service.profileType(),
        status: false,
        title: null,
        values: null,
      });
    }
  }
}
